import { useTranslation } from 'react-i18next';

export default function AuthBranding() {
  const { t } = useTranslation();

  return (
    <div className="hidden lg:flex items-center justify-center bg-primary p-8">
      <div className="flex flex-col gap-6 text-primary-foreground max-w-md text-center">
        <img src="/microphone-256.png" alt="Cibli" className="size-32 mx-auto" />
        <h2 className="text-3xl font-bold">{t('dashboard.auth.homepage.title')}</h2>
        <p className="text-lg opacity-90">{t('dashboard.auth.homepage.subtitle')}</p>
        <div className="flex flex-col gap-3 text-left">
          <div className="flex items-start gap-3">
            <span className="text-2xl">✨</span>
            <div>
              <h3 className="font-semibold">
                {t('dashboard.auth.homepage.features.professionalCV.title')}
              </h3>
              <p className="text-sm opacity-80">
                {t('dashboard.auth.homepage.features.professionalCV.description')}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">💼</span>
            <div>
              <h3 className="font-semibold">
                {t('dashboard.auth.homepage.features.targetedOffers.title')}
              </h3>
              <p className="text-sm opacity-80">
                {t('dashboard.auth.homepage.features.targetedOffers.description')}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-2xl">📱</span>
            <div>
              <h3 className="font-semibold">
                {t('dashboard.auth.homepage.features.simplifiedAccess.title')}
              </h3>
              <p className="text-sm opacity-80">{t('dashboard.auth.homepage.quickAccess')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
